import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/styles';

import { Box, Typography, Grid } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  instructions: {
    ...theme.typography.subtitle2,
  },
  title: {
    ...theme.typography.h5,
    color: theme.palette.error.main,
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
}));

const ErrorMessageBuilder = ({ expirationTime, failureMessage, failureTitle }) => {
  const classes = useStyles();
  return (
    <Grid container direction="row" justifyContent="space-evenly" spacing={4}>
      {failureTitle !== '' && (
        <Grid item xs={12}>
          <Box component="div" className={classes.root}>
            <Typography className={classes.title}>{failureTitle}</Typography>
          </Box>
        </Grid>
      )}

      <Grid item xs={12}>
        <Box className={classes.root}>
          <Typography className={classes.instructions}>{failureMessage}</Typography>
          {expirationTime !== '' && <Typography className={classes.instructions}>{expirationTime}</Typography>}
        </Box>
      </Grid>
    </Grid>
  );
};

ErrorMessageBuilder.propTypes = {
  expirationTime: PropTypes.string,
  failureMessage: PropTypes.string,
  failureTitle: PropTypes.string,
};

ErrorMessageBuilder.defaultProps = {
  expiration: '',
  failureMessage: '',
  failureTitle: '',
};
export default ErrorMessageBuilder;
